<template>
  <v-dialog v-model="isShow" persistent max-width="800" :retain-focus="false">
    <v-card
      class="update-chart-full pt-10 pl-12 pr-12 pb-4 rounded-0"
      height="auto"
      min-height="370"
    >
      <div class="">
        <span class="black--text font-weight-bold mr-5 "
          >ข้อมูลร้องขอใช้บริการ</span
        >
        <v-btn
          absolute
          right
          top
          icon
          x-small
          @click="
            selectedService ? (promtDialog = true) : closeDialogReqService()
          "
          style="z-index: 1;"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>
      <v-divider class="mt-1 mb-4" />
      <div class="text-center mt-1" justify="start">
        <v-row class="mb-0" align="center" style="margin-top: 0px;">
          <v-col
            cols="12"
            lg="6"
            md="6"
            class="text-left"
            style="margin-top: -5px;"
          >
            <span>ประเภทคำร้องขอใช้บริการ</span>
            <v-autocomplete
              v-model="reqType"
              :items="itemsReqType"
              background-color="#FAFAFA"
              outlined
              placeholder="Service"
              no-data-text="ไม่พบข้อมูล"
              class="mt-2"
              dense
              disabled
            >
            </v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            lg="6"
            md="6"
            class="text-left"
            style="margin-top: -5px;"
          >
            <span>ชื่อ Service</span>
            <v-autocomplete
              v-model="selectedService"
              :items="itemsServiceList"
              item-text="serviceName"
              item-value="_id"
              return-object
              :background-color="selectedService ? 'white' : '#FAFAFA'"
              outlined
              placeholder="เลือกชื่อ Service"
              no-data-text="ไม่พบข้อมูล"
              class="mt-2"
              dense
              clearable
              @change="getApprovers()"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <!-- {{ selectedService.approver }}
      <hr>
      {{ approvers }} -->
        <FullLoading :loading="loadingData"></FullLoading>
        <v-row
          class="mb-0"
          align="center"
          style="margin-top: -10px;"
          v-if="approvers.length"
        >
          <v-col
            cols="12"
            lg="12"
            md="12"
            class="text-left"
            style="margin-top: 5px;"
          >
            <div class="">
              <span class="blue--text text--darken-3 font-weight-bold mr-5"
                >ข้อมูลผู้อนุมัติ</span
              >
            </div>
            <v-divider class="mt-1 mb-4" />
          </v-col>
        </v-row>
        <v-row
          class="mb-0"
          align="center"
          style="margin-top: -10px;"
          v-if="approvers.length"
        >
          <v-col
            cols="12"
            lg="12"
            md="12"
            class="text-left"
            style="margin-top: 5px;"
            v-for="item in approvers"
            :key="item.approverNo"
          >
            <v-card class="user-data-panel" style="margin-top: -14px;" outlined>
              <v-row class="pl-1 ml-0 mr-0 pr-1 pt-0 user-data-panel">
                <v-card
                  flat
                  outlined
                  class="ra-head-text-gray blue--text text--darken-3 pl-1 pr-1 mt-1 mb-1"
                  >ลำดับที่ {{ item.approverNo }}</v-card
                >
              </v-row>
              <v-row class="pl-1 pr-1 pt-0">
                <v-col cols="12" sm="2" md="2" lg="2" class="">
                  <v-avatar
                    class="ml-3 mt-0"
                    :size="$vuetify.breakpoint.name !== 'lg' ? '70' : '70'"
                    rounded
                  >
                    <v-img
                      cover
                      :lazy-src="require('@/assets/icons/no_user.png')"
                      :src="
                        item.userImg
                          ? item.userImg
                          : require('@/assets/icons/no_user.png')
                      "
                    >
                    </v-img>
                  </v-avatar>
                </v-col>
                <v-col
                  cols="12"
                  sm="10"
                  md="10"
                  lg="10"
                  style="margin-top: -10px; margin-bottom: -10px;"
                >
                  <v-row class="">
                    <v-col cols="12" lg="5" md="5" sm="5" class="ma-0 pb-0">
                      <span class="ra-head-text-gray">รหัสพนักงาน: </span>
                      <span class="ra-head-text black--text">{{
                        item.employeeId
                      }}</span>
                    </v-col>
                    <v-col cols="12" lg="7" md="7" sm="7" class="ma-0 pb-2">
                      <span class="ra-head-text-gray">ชื่อ - นามสกุล: </span>
                      <span class="ra-head-text black--text">{{
                        item.approverName
                      }}</span>
                    </v-col>
                    <v-col cols="12" lg="5" md="5" sm="5" class="ma-0 pb-0">
                      <span class="ra-head-text-gray">อีเมล: </span>
                      <span class="ra-head-text black--text">{{
                        item.email
                      }}</span>
                    </v-col>
                    <v-col cols="12" lg="7" md="7" sm="7" class="ma-0 pb-2">
                      <span class="ra-head-text-gray">ตำแหน่ง: </span>
                      <span class="ra-head-text black--text">{{
                        item.position
                      }}</span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mb-0" align="center" style="margin-top: 0px;">
          <v-col
            cols="12"
            lg="12"
            md="12"
            class="text-left"
            style="margin-top: -10px;"
          >
            <span>หมายเหตุ</span>
            <v-textarea
              v-model="note"
              class="mt-1"
              outlined
              placeholder="หมายเหตุ"
              rows="2"
              :disabled="!selectedService"
              :background-color="selectedService ? 'white' : '#F5F5F5'"
            ></v-textarea>
          </v-col>
        </v-row>
      </div>
      <v-card-actions class="justify-center pb-2" style="margin-top: -10px;">
        <v-btn
          color="primary"
          outlined
          class="head-search-button mr-4"
          width="140"
          @click="
            selectedService ? (promtDialog = true) : closeDialogReqService()
          "
        >
          ยกเลิก
        </v-btn>
        <v-btn
          color="primary"
          class="head-search-button ml-4 white--text text--lighten-4"
          elevation="0"
          width="140"
          :disabled="!selectedService"
          @click="submitData()"
        >
          ร้องขอใช้บริการ
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog
      v-model="promtDialog"
      persistent
      max-width="385"
      max-height="500"
      style="z-index: 9999"
    >
      <v-card tile class="justify-center">
        <v-card-title class="justify-center">
          <span
            style="font-family: Sarabun; font-style: normal; font-weight: bold; font-size: 16px; line-height: 22px; text-align: center; color: #3776E9;"
          >
            ต้องการออกจากหน้านี้ใช่ไหม
          </span>
        </v-card-title>
        <v-card-subtitle class="layout justify-center pt-1">
          <span
            style="font-family: Sarabun; font-style: normal; font-weight: 400; font-size: 16px; line-height: 22px; text-align: center; color: #757575; margin-top: 12px;"
          >
            ข้อมูลของคุณยังไม่ถูกบันทึก
            <br />คุณแน่ใจหรือไม่ว่าต้องการออกจากหน้านี้
          </span>
        </v-card-subtitle>
        <div class="justify-center">
          <v-btn
            color="primary"
            class="head-search-button ml-11 mt-2 mb-2 white--text text--lighten-4"
            width="295"
            @click="(promtDialog = false), closeDialogReqService()"
          >
            ตกลง ฉันจะออกจากหน้านี้
          </v-btn>
          <v-btn
            color="primary"
            outlined
            class="head-search-button ml-11 mt-2 mb-2"
            width="295"
            @click="promtDialog = false"
          >
            ไม่ ฉันจะอยู่ต่อหน้านี้
          </v-btn>
        </div>
        <v-card-actions class=""> </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { insertRequest, hostImageUrlv3, getServiceById } from '@/API/API'
import swal from 'sweetalert'
import { EventBus } from '@/EventBus'
import FullLoading from '../../_template/FullLoading.vue'
const axios = require('axios')

export default {
  components: {
    FullLoading
  },
  props: {
    isShow: Boolean
  },
  data () {
    return {
      dialogShow: false,
      promtDialog: false,
      loadingData: false,
      serviceName: '',
      urlName: '',
      server: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}`,
      reqType: 'Service',
      selectedService: '',
      note: '',
      approvers: [],
      itemsReqType: [],
      itemsServiceList: [],
      itemsApprovers: []
    }
  },
  computed: {},
  watch: {},
  mounted () {},
  async created () {
    this.tokenUser = this.$store.state.token
    await this.getAllService()
  },
  beforeDestroy () {},
  methods: {
    async closeDialogReqService () {
      this.reqType = ''
      this.selectedService = ''
      this.note = ''
      this.approvers = []
      await this.$emit('closeDialogRequestService')
    },
    async getAllService () {
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/service/serviceSelectorRequest`,
          method: 'POST',
          headers: {
            authorization: this.$store.state.token
          }
        })
          .then(response => {
            if (response.data.success === true) {
              this.itemsServiceList = response.data.result
            } else {
              this.itemsServiceList = []
            }
          })
          .catch(function (thrown) {})
      } catch (error) {
      } finally {
      }
    },
    async getApprovers () {
      if (this.selectedService) {
        try {
          const payload = { serviceId: this.selectedService._id }
          const res = await getServiceById(this.$store.state.token, payload)
          if (res.success) {
            if (res.result) {
              this.approvers = res.result.approver || []
              this.approvers.forEach(e => {
                e.userImg = e.emailOneId
                  ? `${hostImageUrlv3}/_/${e.emailOneId}`
                  : ''
              })
            } else {
              this.approvers = []
            }
          } else {
            this.approvers = []
          }
        } catch (error) {
          this.approvers = []
          console.log(error)
        } finally {
        }
      } else {
        this.approvers = []
      }
    },
    async submitData () {
      if (!this.selectedService || !this.note) {
        swal('', 'กรุณาระบุหมายเหตุ', 'warning', {
          buttons: false,
          timer: 1000
        })
      } else {
        const obj = {
          serviceId: this.selectedService._id,
          comment: this.note
        }
        // console.log('OBJ', obj)
        try {
          const res = await insertRequest(obj, this.$store.state.token)
          if (res.success) {
            swal('สำเร็จ', 'บันทึกข้อมูลสำเร็จ', 'success', {
              button: false,
              timer: 2000
            })
            EventBus.$emit('reloadAfterReqService')
            this.closeDialogReqService()
          } else {
            if (res.msg === 'request service is pending') {
              swal('ผิดพลาด', ' มีคำร้องขอในระบบแล้ว', 'error')
            }
            if (res.msg === 'service is already') {
              swal('ผิดพลาด', 'มีบริการนี้แล้ว', 'error')
            }
            console.log(res.msg)
          }
        } catch (error) {
          swal('ผิดพลาด', 'บันทึกข้อมูลไม่สำเร็จ!', 'error')
          console.log(error)
        } finally {
          this.loading = false
        }
      }
    }
  }
}
</script>
<style>
@import "../../../css/Create.css";
@import "../../../css/ShowService.css";
</style>
